export const INPUT_HELPER_CONFIGURATION: Record<string, { color: string }> = {
    error: {
        color: 'red',
    },
    success: {
        color: 'green',
    },
    warning: {
        color: 'yellow',
    },
};
